// Code review - In Progress
// Documentation - In Progress
import React, { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import download from "../image/download.png";
import MultiSelect from "../ReusableComponents/MultiSelect";
import { BindAPI } from "../services/APIConnection";

const UserDetails = ({ data, data2, data3 }) => {
  
  const [sdp, setSdp] = useState([]);
  const [sdpDropDown, setSdpDropDown] = useState([]);
  useEffect(() => {
    bindUserSdp(data3);
  }, [data3]);

  const bindUserSdp = (sdp) => {
    try {
      if (sdp && sdp.length > 0) {
        const sdpData = sdp.map((item) => ({
          value: item.MstSDPId,
          label: item.SDP_en,
        }));
        setSdpDropDown(sdpData);
      } else {
        setSdpDropDown([]);
      }
    } catch (error) {
      console.error("Error fetching setBindreferelserviceDD data:", error);
    }
  };

  const [bindOrganizationStructure, setBindOrganizationStructure] = useState([
    { value: 1, label: "Head Quarters" },
    { value: 2, label: "Branch/Project" },
    { value: 3, label: "S.D.P." },
  ]);
  const [stateDropDown, setStateDropDown] = useState([]);
  const [locationDropDown, setLocationDropDown] = useState([]);

  useEffect(() => {


    dropDownDatas();
  }, []);
  const dropDownDatas = async () => {
    
    try {

      const statesResponse = await BindAPI("StateAPI/GetState");
      const locationResponse = await BindAPI("LocationAPI/GetLocation");


      const statesData = statesResponse.data.Table.map((item) => ({
        value: item.MstStateId,
        label: item.StateName_en,
      }));
      const locationData = locationResponse.data.Table.map((item) => ({
        value: item.MstLocationId,
        label: item.LocationName_en,
      }));


      setStateDropDown(statesData);
      setLocationDropDown(locationData);
    } catch (error) { }
  };
  return (
    <div class="w-full">
      <div>
        <div className={mainTable.mainContentScreen}>
          <form class="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit ">
            <div className={mainTable.grid3}>
              <InputText
                inputType={"text"}
                title={"First Name"}
                name={"firstName"}
                content={data.FirstName}
                classStar={"text-red-500"}
                disabled={true}
              />

              <InputText
                inputType={"text"}
                title={"Middle Name"}
                name={"middleName"}
                content={data.MiddleName}
                disabled={true}
              />
              <InputText
                inputType={"text"}
                title={"Last Name"}
                name={"lastName"}
                content={data.LastName}
                classStar={"text-red-500"}
                disabled={true}
              />

              <InputText
                inputType={"email"}
                title={"Email"}
                name={"email"}
                placeholder={"abc@gmail.com"}
                content={data.UserEmail}
                classStar={"text-red-500"}
                disabled={true}
              />

              <InputText
                inputType={"text"}
                title={"Mobile Number"}
                name={"phone"}
                placeholder={"9347583939"}
                content={data.UserMobile}
                classStar={"text-red-500"}
                disabled={true}
              />
              <InputText
                inputType={"text"}
                title={"Designation"}
                name={"designation"}
                content={data.Designation}
                classStar={"text-red-500"}
                disabled={true}
              />
              
              {/* <AutoDropDown
                title="Designation"
                options={[]}
                placeholder="Select"
                name="state"
                selectedOption={data2[0]}
                Class="custom-class"
                //disabled="false"
                tabIndex="1"
                classStar={"text-red-500"}
                disabled={true}
              />*/}
              <AutoDropDown
                title="Role/Groups"
                options={[]}
                placeholder="Select"
                name="role"
                selectedOption={data2[1]}
                Class="custom-class"
                //disabled="false"
                tabIndex="1"
                classStar={"text-red-500"}
                disabled={true}
              /> 

              <DropDown
                classDiv="hidden"
                title="Country"
                options={[]}
                placeholder="Select"
                name="country"
                selectedOption={"country"}
              />
<InputText
                inputType={"text"}
                title={"State"}
                name={"state"}
                content={data.State}
                // classStar={"text-red-500"}
                disabled={true}
              />
              <InputText
                inputType={"text"}
                title={"City"}
                name={"location"}
                content={data.Location}
                // classStar={"text-red-500"}
                disabled={true}
              />
              {/* <DropDown
                title="State"
                classStar={"text-red-500"}
                options={stateDropDown}
                placeholder="Select"
                name="state"

                selectedOption={data.MstStateId
                }
                disabled={true}
              />
              <DropDown
                title="City"
                classStar={"text-red-500"}
                options={locationDropDown}
                name="state"

                selectedOption={data.MstLocationId
                }
                disabled={true}
              /> */}



              <div className="flex">
                {data && data.UserProfileImg != null && data.UserProfileImg != "" && (
                  <div>
                    <img
                      src={data ? data?.UserProfileImg : download}
                      alt="Image"
                      className="rounded-full w-20 h-20"
                    />
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
